import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Text, Button, Div } from 'ui'
import { GAHandler } from 'utils/GA'

import Author from '../Author'
import Cover from '../Cover'
import Alert from './Alert'
import { ReactComponent as ShareSVG } from 'assets/icons/share.svg'

import {
  InfoContainer,
  CoverWrapper,
  Metadata,
  Check,
  CTA,
} from './styles'
import useResponsive from 'utils/hooks/useResponsive'


const Info = ({
  children,
  cover,
  author,
  onClickCTA,
  urlShare,
  renderValueText: ValueText
}) => {

  const { t } = useTranslation()
  const { isMobileBig } = useResponsive()

  const [isLinkCopied, setIsLinkCopied] = useState(false)

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(urlShare)
    setIsLinkCopied(true)
    GAHandler('share');

    setTimeout(() => {
      setIsLinkCopied(false)
    }, 3000);
  }

  return (
    <Div
      display='flex'
      flexDirection='column'
      height={isMobileBig ? 'fit-content' : 360}
    >
     <InfoContainer>
      <CoverWrapper>
        <Cover src={cover.src} alt={cover.alt} />
      </CoverWrapper>

      <Metadata>
        <div style={{ display: 'flex', flexDirection: 'column', height:'100%' }}>
          {children}

          <div style={{  display: 'flex', flexDirection: 'column', justifyContent:'end' }}>
            <Author
              src={author.avatar}
              alt={author.name}
              name={author.name}
              videos={author.videos}
            />

            <div style={{ height: 20, marginBottom: 12 }}>
              {ValueText && (
                <Text size='sm' color='headline'>
                  <ValueText />
                </Text>
              )}
            </div>
          </div>
        </div>


        <div style={{ display: 'flex', gap: '16px' }}>
          <CTA onClick={onClickCTA} size='large' isFull>
            {t('watchNow')}
          </CTA>

          <div style={{ position: 'relative' }}>
            <Alert isOpen={isLinkCopied}>
              <Check /> {t('linkCopied')}
            </Alert>

            <Button variant='icon' size='large' onClick={handleCopyUrl}>
              <ShareSVG />
            </Button>
          </div>
        </div>
      </Metadata>

    </InfoContainer>
    </Div>
  )
}

export default Info